var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "103px",
    viewBox: "0 0 138 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 53.7999093,
    y: 3.58584006,
    width: 78.9065336,
    height: 5.73734409,
    rx: 2.86867205
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-17.4%",
    width: "102.5%",
    height: "134.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-3",
    cx: 12.9021345,
    cy: 6.45451211,
    rx: 2.14215261,
    ry: 2.15150404
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.3%",
    y: "-23.2%",
    width: "146.7%",
    height: "146.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-5",
    cx: 6.72530416,
    cy: 6.6410924,
    rx: 2.14215261,
    ry: 2.15150404
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.3%",
    y: "-23.2%",
    width: "146.7%",
    height: "146.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 13.3208955,
    y: 78.0223881,
    width: 110.373134,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-46.9%",
    width: "106.3%",
    height: "231.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 13.3208955,
    y: 57.0895522,
    width: 110.373134,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-46.9%",
    width: "106.3%",
    height: "231.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "50.1366244%",
    x2: "19.6413923%",
    y2: "49.8162792%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "50.2235201%",
    x2: "19.6413923%",
    y2: "49.6994292%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-13",
    cx: 100.097015,
    cy: 80.6865672,
    r: 6.85074627
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.1%",
    y: "-36.5%",
    width: "202.2%",
    height: "202.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-15",
    cx: 78.7835821,
    cy: 59.7537313,
    r: 6.85074627
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.1%",
    y: "-36.5%",
    width: "202.2%",
    height: "202.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 13.3208955,
    y: 35.7761194,
    width: 110.373134,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-46.9%",
    width: "106.3%",
    height: "231.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "50.1092706%",
    x2: "19.6413923%",
    y2: "49.8530622%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-20",
    cx: 106.947761,
    cy: 38.4402985,
    r: 6.85074627
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.1%",
    y: "-36.5%",
    width: "202.2%",
    height: "202.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Lifestyle-Assessment-Intro",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176.000000, -1566.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.992537, 1566.976563)",
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6,0 L132.693103,0 C134.681329,7.88581843e-17 136.293103,1.6117749 136.293103,3.6 L136.293103,12.9090242 L136.293103,12.9090242 L0,12.9090242 L0,3.6 C2.00601859e-16,1.6117749 1.6117749,-7.88581843e-17 3.6,0 Z",
    id: "Rectangle",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.693103,13.3590242 C133.562952,13.3590242 134.350452,13.7116 134.92049,14.2816379 C135.490528,14.8516757 135.843103,15.6391757 135.843103,16.5090242 L135.843103,16.5090242 L135.843103,101.518726 L0.45,101.518726 L0.45,16.5090242 C0.45,15.6391757 0.80257576,14.8516757 1.37261364,14.2816379 C1.94265152,13.7116 2.73015152,13.3590242 3.6,13.3590242 L3.6,13.3590242 Z",
    id: "Rectangle-Copy-7",
    stroke: "#D9D9D9",
    strokeWidth: 0.9,
    fill: "#F8F8F8",
    transform: "translate(68.146552, 57.438875) rotate(-180.000000) translate(-68.146552, -57.438875) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "url(#linearGradient-11)",
    x: 13.3208955,
    y: 78.0223881,
    width: 83.7313433,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "url(#linearGradient-12)",
    x: 13.3208955,
    y: 57.0895522,
    width: 65.4626866,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "url(#linearGradient-19)",
    x: 13.3208955,
    y: 35.7761194,
    width: 93.6268657,
    height: 5.32835821,
    rx: 2.6641791
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF520B",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(75.685210, 36.156716)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.598563,
    y1: 42.7606693,
    x2: 21.598563,
    y2: 46.2206422,
    id: "Path-Copy-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.285130146,
    y1: 21.8278335,
    x2: 0.285130146,
    y2: 25.2878064,
    id: "Path-Copy-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.4213514,
    y1: 42.7606693,
    x2: 24.4213514,
    y2: 46.2206422,
    id: "Path-Copy-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1079186,
    y1: 21.8278335,
    x2: 3.1079186,
    y2: 25.2878064,
    id: "Path-Copy-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.2441399,
    y1: 42.7606693,
    x2: 27.2441399,
    y2: 46.2206422,
    id: "Path-Copy-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.93070705,
    y1: 21.8278335,
    x2: 5.93070705,
    y2: 25.2878064,
    id: "Path-Copy-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.4493093,
    y1: 0.514400653,
    x2: 28.4493093,
    y2: 3.97437352,
    id: "Path-Copy-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.2720977,
    y1: 0.514400653,
    x2: 31.2720977,
    y2: 3.97437352,
    id: "Path-Copy-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.0948862,
    y1: 0.514400653,
    x2: 34.0948862,
    y2: 3.97437352,
    id: "Path-Copy-9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 13.3208955,
    y: 22.0746269,
    width: 37.6791045,
    height: 4.18656716,
    rx: 2.09328358
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 13.3208955,
    y: 45.0895522,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#D9D9D9",
    x: 13.3208955,
    y: 65.6641791,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#D9D9D9",
    x: 118.746269,
    y: 45.0895522,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#D9D9D9",
    x: 118.746269,
    y: 65.6641791,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#D9D9D9",
    x: 13.3208955,
    y: 86.2164179,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#D9D9D9",
    x: 118.746269,
    y: 86.2164179,
    width: 4.94776119,
    height: 1.90298507,
    rx: 0.951492537
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.79973a2abebbf710236ef5a3bd962842.svg";
export { ForwardRef as ReactComponent };